export const JIRA_CONNECTOR_CONSTANT = {
    PLAN_TRAIT: 'jira_connector',
};
